import { AddCustomerContainer } from "./container";

export const AddCustomerPane = () => {
  return <AddCustomerContainer />;
};
